import React, { useState, useEffect, useRef, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAuthenticationContext } from "../Contexts/AuthenticationContext";
import CryptoJS from "crypto-js";
import TextField from "@mui/material/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { forgotPasswordAPI } from "../api/api";
import { checkEmailValidity } from "../utilities/utilities";
import pageClasses from "./page.module.css";
import "./login.css";

import MyButton from "../components/MyButton";
import MySpinner from "../components/MySpinner";

import ModalInfo from "../components/modals/ModalInfo";
import ModalAlert from "../components/modals/ModalAlert";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [isInvalidEmail, setIsInvalidEmail] = useState(false);

  const [forgotPasswordResponse, setForgotPasswordResponse] = useState(null);
  const [showSuccessfullMessage, setShowSuccessfullMessage] = useState(false);

  const [showModalAlert, setShowModalAlert] = useState(false);
  const [modalAlertMessage, setModalAlertMessage] = useState("An Error!");

  const [isBusy, setIsBusy] = useState(false);

  useEffect(() => {
    if (forgotPasswordResponse) {
      setIsBusy(false);
      console.log(
        `Got a new forgotPasswordResponse: ${JSON.stringify(
          forgotPasswordResponse,
        )}`,
      );
      if (forgotPasswordResponse.success) {
        setShowSuccessfullMessage(true);
      } else {
        let message = `Unable to reset password. Error: ${
          forgotPasswordResponse.errorMessage || "Unknown"
        }.`;
        setModalAlertMessage(message);
        setShowModalAlert(true);
      }
    }
  }, [forgotPasswordResponse]);

  const handleSubmitForgotPassword = async (e) => {
    e.preventDefault();
    console.log(
      `Check validity of form inputs, then call the API..., email: ${email}`,
    );

    //check validity of restaurantName, user, email
    if (!email || !checkEmailValidity(email)) {
      setIsInvalidEmail(true);
      console.log("Invalid email, returning...");
      //setModalAlertMessage("Invalid parameters, please check the form inputs.");
      //setShowModalAlert(true);
      return;
    }

    console.log("All parameters are valid, call the API...TBD>>>>>");
    forgotPasswordAPI(email, setForgotPasswordResponse);
  };

  return (
    <div className={pageClasses.pagebody}>
      <div>
        <div className="login_container">
          <h2>Forgot Password</h2>
          {!showSuccessfullMessage ? (
            <form className="login_form" onSubmit={handleSubmitForgotPassword}>
              <div className="login_element">
                <TextField
                  type="text"
                  id="email"
                  className="input_element"
                  label="Your Email"
                  autoComplete="off"
                  onChange={(e) => {
                    setIsInvalidEmail(false);
                    setEmail(e.target.value);
                  }}
                  value={email}
                  error={isInvalidEmail}
                  helperText={isInvalidEmail ? "Invalid Email" : ""}
                  required
                />
              </div>
              <div className="button_div">
                <MyButton
                  variant={"primary"}
                  onClickHandler={handleSubmitForgotPassword}
                  title={"Reset Password"}
                />
              </div>
            </form>
          ) : (
            <form className="login_form">
              <div className="login_element">
                Password reset link sent to your email address ({`${email}`}).
                Please check your email.
              </div>
            </form>
          )}
        </div>

        {showModalAlert && (
          <ModalAlert
            show={showModalAlert}
            alertMessage={modalAlertMessage}
            handleClose={() => {
              setShowModalAlert(false);
            }}
          />
        )}

        {isBusy && <MySpinner />}
      </div>
    </div>
  );
};

export default ForgotPassword;
